<template>
    <div>
        <div style="padding:100px 0 0px 0;text-align: center; position: relative;">
            <span style="font-size:20px; ">
                无锡立信高等职业技术学校{{ year }}级新生录取情况一览表《初中生》
            </span>

            <div style="position: absolute; top: 100px; right: 20%; ">
                <el-button size="small" icon="el-icon-upload" @click="exportStudents" plain type="primary">导出</el-button>
            </div>
        </div>
        <div style="padding:50px">
            <table id="table" class="dtable">
                <thead style="background-color: #ccccaa;">


                    <tr>
                        <td rowspan="2" >系科</td>
                        <td colspan="2"></td>
                        <td>招生数</td>
                        <td colspan="4">录取性质</td>

                    </tr>
                    <tr>
                        <td>录取工种</td>
                        <td>学制</td>
                        <td>计划</td>
                        <td>总人数</td>
                        <td>男</td>
                        <td>女</td>
                        <td>住宿</td>

                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row, i) in DataList" :key="i" :class="row[0]=='合计'?'hd':''">
                        <td  v-if="spanData[i]" :rowspan="spanData[i]">{{ row[0] }}</td>
                        <td class="xk" :data-name="row[0]">{{ row[1] }}</td>
                        <td>{{ row[2] }}</td>
                        <td>{{ row[3] }}</td>
                        <td>{{ row[4] }}</td>
                        <td>{{ row[5] }}</td>
                        <td>{{ row[6] }}</td>
                        <td>{{ row[7] }}</td>


                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>

export default {
    name: 'tableread',
    data() {
        return {
            year: localStorage.getItem("year"),
            DataList: [],
            spanData:{}
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        getData() {
            this.$http.post("/api/wxlx_exportStudents", { only_data: 1 }).then(res => {
                this.DataList = res.data
                let spanData={}
                this.$nextTick(e => {
                 
                        let xk = "", rowspan = 0, index = 0;
                        $('.xk').each((idx, ele) => {
                          
                            if (xk != $(ele).attr("data-name")) {

                                if (xk != "") {
                                    spanData[index] = rowspan
                                }
                                xk = $(ele).attr("data-name")
                                rowspan = 1
                                index = idx
                            } else {
                                rowspan++
                                
                            }
                        })
                        spanData[ this.DataList.length-1] = 1
                        this.spanData= spanData

                })
            })
        },
        exportStudents(){
            this.$http.post("/api/wxlx_exportStudents", {}).then((res) => {
					if (res.data.url) {
						window.open(res.data.url);
					}
				});
        }
    }
}

</script>

<style scoped>
    .hd{
        background-color: #ccccaa;
    }
</style>